import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-faire_home_footer_help_center-click';

/**
 * Help Center link click event from faire.com footer
 */
export function trackHelpCenterFaireHomeFooterHelpCenterClick(
  retailerToken: string,
  brandToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerToken, brandToken },
  });
}
